module.exports = __webpack_public_path__ + "static/media/OnTrack.5b33899e.svg";